﻿/**
 * 上传组件运行模式
 *
 * @author LCTR
 * @date 2022-06-24
 */
export enum RunMode {
    /**
     * 添加文件后会自动校验，自动上传
     */
    全自动 = 'AT',

    /**
     * 添加文件后需要主动调用校验方法以及上传方法
     */
    手动挡 = 'MT',

    /**
     * 添加文件后会自动校验，但需要主动调用上传方法
     */
    半自动 = 'AMT'
}